export const ENVIRONMENTS = ['development', 'test', 'acceptance', 'production'] as const;

export type Environment = (typeof ENVIRONMENTS)[number];

export enum FeatureFlag {
  CARE_CONNECT = 'CARE_CONNECT',
  INTERCOM_MAPPINGS = 'INTERCOM_MAPPINGS',
}

export type EnvironmentConfig = {
  environment: Environment;
  fromVersion: string;
};

export type FeatureFlagConfig = {
  id: FeatureFlag;
  nameKey: string;
  enabledIn: EnvironmentConfig[];
  disabledIn: Environment[];
};
